import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-search-icon',
  templateUrl: './general-search.component.html'
})
export class GeneralSearchComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
